import { render, staticRenderFns } from "./Testimony.vue?vue&type=template&id=0991684e&"
import script from "./Testimony.vue?vue&type=script&lang=js&"
export * from "./Testimony.vue?vue&type=script&lang=js&"
import style0 from "./Testimony.vue?vue&type=style&index=0&id=0991684e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports